"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartQuantityUpdateMapper = void 0;
var CartQuantityUpdateMapper = /** @class */ (function () {
    function CartQuantityUpdateMapper(data) {
        this.localData = data;
    }
    CartQuantityUpdateMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return CartQuantityUpdateMapper;
}());
exports.CartQuantityUpdateMapper = CartQuantityUpdateMapper;
//# sourceMappingURL=CartQuantityUpdateMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/CartQuantityUpdateMapper.js
// module id = 2220
// module chunks = 8